<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Evento</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical/>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="abrirDialogNvEvento()">Novo</v-btn>
                </v-toolbar>
            </template>

            <template  v-slot:item.action="{ item }">
                <v-icon v-if="item.data_inicio > editedItem.dataAtual" title="Editar Evento" class="mr-2" @click="editarEvento(item, 1)">mdi-pencil</v-icon>
                <v-icon v-else title="Evento Finalizado" class="mr-2" @click="editarEvento(item, 2)">mdi-eye</v-icon>
            </template>
        </v-data-table>

        <v-dialog persistent v-model="dialogNovoEvento"  fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="#042333">
                    <v-btn icon dark @click="fecharDialogNvEvento()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Cadastro de Evento</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-row v-if="!cadastroEvento">
                        <v-col class="pa-0" cols="3" xs="12">
                            <v-text-field
                                outlined
                                v-model="editedItem.nomeEvento"
                                label="Nome do Evento*"
                                placeholder="Ex: Black Friday"
                                autofocus
                                style="margin-right: 10px"
                                :error-messages="nomeEventoErrors"
                                @input="$v.editedItem.nomeEvento.$touch()"
                                @blur="$v.editedItem.nomeEvento.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="2" xs="12">
                            <v-select
                                v-model="editedItem.tipoEvento"
                                :items="selects.tipoEvento.items"
                                label="Tipo de Evento*"
                                placeholder="Selecione..."
                                item-text="descricao"
                                item-value="id_tipo_evento"
                                height="10"
                                outlined
                                chips
                                style="margin-right: 10px"
                                :error-messages="tipoEventoErrors"
                                @input="$v.editedItem.tipoEvento.$touch()"
                                @blur="$v.editedItem.tipoEvento.$touch()"
                            ></v-select>
                        </v-col>
                        <v-col class="pa-0" cols="2" xs="12">
                            <v-text-field
                                v-model="editedItem.percentagemCrescimento"
                                label="Percentual Crescimento*"
                                placeholder="0%"
                                height="10"
                                outlined
                                chips
                                style="margin-right: 10px"
                                :error-messages="percentagemCrescimentoErrors"
                                @input="$v.editedItem.percentagemCrescimento.$touch()"
                                @blur="$v.editedItem.percentagemCrescimento.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="2" xs="12">
                            <v-text-field
                                outlined
                                v-model="editedItem.periodoInicial"
                                label="Digite o Período Inicial*"
                                autofocus
                                type="date"
                                style="margin-right: 10px"
                                :error-messages="periodoInicialErrors"
                                @input="$v.editedItem.periodoInicial.$touch()"
                                @blur="$v.editedItem.periodoInicial.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="2" xs="12">
                            <v-text-field
                                outlined
                                v-model="editedItem.periodoFinal"
                                label="Digite o Período Final*"
                                autofocus
                                type="date"
                                style="margin-right: 10px"
                                :error-messages="periodoFinalErrors"
                                @input="$v.editedItem.periodoFinal.$touch()"
                                @blur="$v.editedItem.periodoFinal.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="1" xs="12">
                            <v-text-field
                                outlined
                                v-model="editedItem.meta"
                                label="Meta*"
                                placeholder="Ex: 100.00"
                                autofocus
                                style="margin-right: 10px"
                                :error-messages="metaErrors"
                                @input="$v.editedItem.meta.$touch()"
                                @blur="$v.editedItem.meta.$touch()"
                            ></v-text-field>
                        </v-col>

                        <v-col class="pa-0" cols="12" xs="12" style="text-align: right;margin-top: -10px;">
                            <v-btn v-if="editedItem.idevento > 0" class="default mr-2" @click="cadastroEvento = true">Ir para adicionar Produtos</v-btn>
                            <v-btn color="primary" dark class="mr-2" @click="salvarEvento()">Salvar</v-btn>
                        </v-col>

                    </v-row>

                    <v-row v-else-if="editedItem.soVisualizacao">
                        <h2 style="margin-left: 10px">#{{editedItem.idevento}} - {{editedItem.nomeEvento}} ({{editedItem.tipoEventoDesc}}) de {{editedItem.periodoInicial}} até {{editedItem.periodoFinal}}</h2>
                        <v-spacer/>
                        <h3 style="margin-right: 10px">Percentual: {{editedItem.percentagemCrescimento}}% / Meta: {{editedItem.meta}} / Realizado: {{editedItem.realizado}}</h3>
                    </v-row>

                    <v-row v-else>

                        <v-col class="pa-0" cols="4" xs="12">
                            <h2>#{{editedItem.idevento}} - {{editedItem.nomeEvento}} ({{editedItem.tipoEventoDesc}})</h2>
                        </v-col>
                        <v-col class="pa-0" cols="4" xs="12" style="margin-left:auto;margin-right:0;">
                            <v-autocomplete
                                v-model="editedItem.idproduto"
                                :items="selects.produtos.items"
                                label="Descrição do Produto"
                                placeholder="Escolha um produto para adicionar ao evento..."
                                item-text="descricao_produto"
                                item-value="idproduto"
                                height="10"
                                outlined
                                chips
                                style="margin-right: 10px"
                                :error-messages="filtroDisponibilidadeDrpErrors"
                                @input="$v.editedItem.filtro_disponibilidade_drp.$touch()"
                                @blur="$v.editedItem.filtro_disponibilidade_drp.$touch()"
                            ></v-autocomplete>
                        </v-col>

                        <v-btn color="primary" dark class="mt-2 ml-5" @click="adicionarProdutoAoEvento()">Adicionar {{editedItem.index}} </v-btn>

                    </v-row>
                    <v-row>

                        <v-col class="mt-4" cols="12" xs="12">
                            <v-divider/>
                            <v-data-table
                                :headers="headersNovoEvento"
                                :items="dessertsNovoEvento"
                                :height="320"
                                :fixed-header="true"
                                class="elevation-3"
                            >
                                <template  v-slot:item.action="{ item }">
                                    <v-icon v-if="!editedItem.soVisualizacao" title="Delete Produto" class="mr-2" @click="excluirProduto(item)">mdi-delete</v-icon>
                                    <v-icon v-else title="Delete Produto" class="mr-2" color="orange">mdi-delete-off</v-icon>
                                </template>
                            </v-data-table>
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>

import PedidoAPI from "./../../api/pedido";
import {required} from 'vuelidate/lib/validators'
import {mapGetters} from "vuex";

export default {

    data() {
        return {

            cadastroEvento: false,

            editedItem: {
                idevento: '',
                nomeEvento: '',
                tipoEvento: '',
                tipoEventoDesc: '',
                percentagemCrescimento: '',
                periodoInicial: '',
                periodoFinal: '',
                meta: '',
                realizado: '',
                idproduto: '',
                dataAtual: '',
                soVisualizacao: false
            },

            dialogNovoEvento: false,

            selects: {
                tipoEvento:{
                    items: []
                },
                produtos: {
                    items: []
                }
            },

            desserts: [],
            headers: [
                {text: 'ID', value: 'id_evento'},
                {text: 'Tipo Evento', value: 'descricao'},
                {text: 'Evento', value: 'nome_evento'},
                {text: 'Percentual Cresc.', value: 'percentual'},
                {text: 'Meta', value: 'vlr_meta'},
                {text: 'Valor Realizado', value: 'vlr_realizado'},
                {text: 'Qtde. Itens', value: 'qtde_itens'},
                {text: 'Data Início', value: 'data_inicio'},
                {text: 'Data Final', value: 'data_fim'},
                {text: 'Ações', value: 'action', sortable: false},
            ],
            dessertsNovoEvento: [],
            headersNovoEvento: [
                {text: 'Id Evento', value: 'id_evento'},
                {text: 'Id Produto', value: 'idproduto'},
                {text: 'Descrição Produto', value: 'idproduto'},
                {text: 'Projeção de vendas', value: 'consumo_medio_mensal'},
                {text: 'Desvio Padrao', value: 'desvio_padrao_consumo'},
                {text: 'Data', value: 'data_inclusao'},
                {text: 'Percentual', value: 'percentual'},
                {text: 'Ações', value: 'action', sortable: false},
            ],
        }
    },



    validations: {
        editedItem: {
            nomeEvento: {
                required,
            },
            tipoEvento: {
                required,
            },
            percentagemCrescimento: {
                required,
            },
            periodoInicial: {
                required,
            },
            periodoFinal: {
                required,
            },
            meta: {
                required,
            }
        }
    },

    computed: {

        ...mapGetters({
            grupoCompra: "usuario/getGrupoCompras"
        }),

        nomeEventoErrors() {
            const errors = []
            if (!this.$v.editedItem.nomeEvento.$dirty) return errors
            !this.$v.editedItem.nomeEvento.required && errors.push('Campo Obrigatório.')
            return errors
        },
        tipoEventoErrors() {
            const errors = []
            if (!this.$v.editedItem.tipoEvento.$dirty) return errors
            !this.$v.editedItem.tipoEvento.required && errors.push('Campo Obrigatório.')
            return errors
        },
        percentagemCrescimentoErrors() {
            const errors = []
            if (!this.$v.editedItem.percentagemCrescimento.$dirty) return errors
            !this.$v.editedItem.percentagemCrescimento.required && errors.push('Campo Obrigatório.')
            return errors
        },
        periodoInicialErrors() {
            const errors = []
            if (!this.$v.editedItem.periodoInicial.$dirty) return errors
            !this.$v.editedItem.periodoInicial.required && errors.push('Campo Obrigatório.')
            return errors
        },
        periodoFinalErrors() {
            const errors = []
            if (!this.$v.editedItem.periodoFinal.$dirty) return errors
            !this.$v.editedItem.periodoFinal.required && errors.push('Campo Obrigatório.')
            return errors
        },
        metaErrors() {
            const errors = []
            if (!this.$v.editedItem.meta.$dirty) return errors
            !this.$v.editedItem.meta.required && errors.push('Campo Obrigatório.')
            return errors
        },

    },

    watch: {
        grupoCompra(){
            this.buscarEventos();
            this.buscarProdutos();
        }
    },

    created() {

        /*
        **      falta finalizar o cadastro de itens do evento, inda nao esta 100% correto
        */

        this.buscarEventos();
        this.buscarTiposEvento();
        this.buscarProdutos();

    },

    methods: {

        excluirProduto(item){

            if (confirm('Deseja realmente excluir o produto?')) {

                const headers = this.Helpers.iniciarRequisicao();

                const params = {
                    idevento: this.editedItem.idevento,
                    idproduto: item.idproduto
                }

                this.$store.dispatch("loading/addRequisicao",
                    PedidoAPI.excluirProdutoEvento(headers, params)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            if(response.status == 200){
                                this.getItensEvento();
                            }

                        })
                        .catch(() => {
                            this.Helpers.logout();
                        })
                )
            }

        },

        editarEvento(item, controller){

            if(controller === 2){

                this.editedItem.soVisualizacao = true;
                this.cadastroEvento = true;

            }else{

                this.editedItem.soVisualizacao = false;
                this.cadastroEvento = false;

            }

            this.editedItem.idevento = item.id_evento
            this.editedItem.nomeEvento = item.nome_evento
            this.editedItem.tipoEvento = item.id_tipo
            this.editedItem.tipoEventoDesc = item.descricao
            this.editedItem.percentagemCrescimento = item.percentual
            this.editedItem.periodoInicial = item.data_inicio
            this.editedItem.periodoFinal = item.data_fim
            this.editedItem.meta = item.vlr_meta
            this.editedItem.realizado = item.vlr_realizado

            this.dialogNovoEvento = true;

            this.getItensEvento();

        },

        abrirDialogNvEvento(){

            this.dialogNovoEvento=true;
            this.cadastroEvento=false;

            this.editedItem.idevento = ''
            this.editedItem.nomeEvento = ''
            this.editedItem.tipoEvento = ''
            this.editedItem.tipoEventoDesc = ''
            this.editedItem.percentagemCrescimento = ''
            this.editedItem.periodoInicial = ''
            this.editedItem.periodoFinal = ''
            this.editedItem.meta = ''
            this.editedItem.realizado = ''

            this.dessertsNovoEvento = [];
        },

        fecharDialogNvEvento(){

            this.dialogNovoEvento=false;
            this.buscarEventos();

        },

        getItensEvento(){

            const headers = this.Helpers.iniciarRequisicao();

            const params = {
                idevento: this.editedItem.idevento
            }

            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.getItensEvento(headers, params)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        this.dessertsNovoEvento = response.data.itens_evento;

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        },

        adicionarProdutoAoEvento(){

            const headers = this.Helpers.iniciarRequisicao();

            const params = {
                grupo: this.grupoCompra,
                idevento: this.editedItem.idevento,
                idproduto: this.editedItem.idproduto
            }

            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.addProdutoEvento(headers, params)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if(response.data.existe > 0){
                            alert('Produto já adicionado ao evento.')
                        }

                        this.getItensEvento();

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        },

        salvarEvento(){

            if (!this.$v.$invalid) {

                const headers = this.Helpers.iniciarRequisicao();

                const params = {
                    grupo: this.grupoCompra,
                    idevento: this.editedItem.idevento,
                    idproduto: this.editedItem.idproduto,
                    tipo: this.editedItem.tipoEvento,
                    nome: this.editedItem.nomeEvento,
                    periodoInicial: this.editedItem.periodoInicial,
                    periodoFinal: this.editedItem.periodoFinal,
                    percentagemCrescimento: this.editedItem.percentagemCrescimento,
                    meta: this.editedItem.meta
                }

                this.$store.dispatch("loading/addRequisicao",
                    PedidoAPI.cadastrarEvento(headers, params)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            this.editedItem.idevento = response.data.id_evento;

                            this.cadastroEvento = true;

                            this.selects.tipoEvento.items.forEach(tipo => {
                                if(tipo.id_tipo_evento === this.editedItem.tipoEvento)
                                    this.editedItem.tipoEventoDesc = tipo.descricao
                            });
                        })
                        .catch(() => {
                            this.Helpers.logout();
                        })
                )
            }

        },

        buscarProdutos(){

            const headers = this.Helpers.iniciarRequisicao();

            const params = {
                grupo: this.grupoCompra
            }

            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.getProdutosEvento(headers, params)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        const produtos = response.data.produtos;

                        produtos.forEach(item => {
                            this.selects.produtos.items.push({
                                idproduto: item.idproduto,
                                descricao_produto: item.idproduto + ' - ' + item.descricao_produto
                            });
                        });
                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        },

        buscarTiposEvento(){

            const headers = this.Helpers.iniciarRequisicao();

            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.getTiposEvento(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        this.selects.tipoEvento.items = response.data.tipo_evento;

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        },

        buscarEventos(){

            const headers = this.Helpers.iniciarRequisicao();

            const params = {
                grupo: this.grupoCompra
            }

            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.getEventos(headers, params)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        this.desserts = response.data.eventos
                        this.editedItem.dataAtual = response.data.data_atual

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        }

    }
};
</script>
<style></style>
